/* Only Blankabox: native variant IDs, existing product form and cart events. */
class BlankaboxVariantPicker extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.scope = this.closest('[data-bb-variant-scope]');
    if (!this.scope) return;
    this.abortController = new AbortController();
    const options = { signal: this.abortController.signal };
    this.addEventListener('change', (event) => {
      const input = event.target.closest('[data-bb-length-choice]');
      if (!input || input.disabled) return;
      this.select(input, true);
    }, options);
    if (this.hasAttribute('data-update-url')) {
      window.addEventListener('popstate', () => this.selectFromUrl(), options);
    }
    this.selectFromUrl();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  selectFromUrl() {
    const choices = [...this.querySelectorAll('[data-bb-length-choice]')];
    const requestedId = this.hasAttribute('data-update-url')
      ? new URL(window.location.href).searchParams.get('variant') : null;
    const selected = choices.find((input) => input.value === requestedId)
      || choices.find((input) => input.hasAttribute('data-primary') && !input.disabled)
      || choices.find((input) => !input.disabled)
      || choices.find((input) => input.hasAttribute('data-primary')) || choices[0];
    if (selected) this.select(selected, false);
  }

  select(input, updateUrl) {
    const form = this.scope.querySelector('product-form-component');
    const variantInput = form?.querySelector('input[name="id"]');
    if (!variantInput) return;
    const available = input.dataset.available === 'true';
    input.checked = true;
    variantInput.value = input.value;
    variantInput.setAttribute('value', input.value);
    variantInput.disabled = !available;
    form.dataset.currentVariantId = input.value;
    form.toggleAttribute('data-variant-selection-invalid', !available);
    const quantity = form.querySelector('input[name="quantity"]');
    if (quantity) quantity.value = input.dataset.quantity || '1';

    const container = form.querySelector('add-to-cart-component');
    if (container) container.dataset.bbUnitPrice = input.dataset.price;
    const button = form.querySelector('[ref="addToCartButton"]');
    if (button) {
      button.disabled = !available;
      button.removeAttribute('data-added');
      const label = button.querySelector('.bb-add-to-cart-label');
      if (label) label.textContent = available ? this.dataset.addLabel : this.dataset.soldoutLabel;
      button.querySelectorAll('.bb-add-to-cart-separator, [data-bb-add-to-cart-total], .add-to-cart-icon')
        .forEach((node) => { node.hidden = !available; });
      const total = button.querySelector('[data-bb-add-to-cart-total]');
      if (total) total.textContent = input.dataset.money;
    }
    this.scope.querySelectorAll('[data-bb-variant-price]').forEach((node) => {
      node.textContent = input.dataset.money;
    });
    this.scope.querySelectorAll('[data-bb-variant-summary]').forEach((node) => {
      node.textContent = input.dataset.summary;
    });
    this.scope.querySelectorAll('[data-bb-variant-unit-price]').forEach((node) => {
      node.textContent = input.dataset.unitPrice;
    });
    this.scope.querySelectorAll('[data-bb-variant-link]').forEach((link) => {
      const url = new URL(link.href, window.location.href);
      url.searchParams.set('variant', input.value);
      link.href = url.href;
    });
    const stickyButton = this.scope.querySelector('[data-bbp-sticky-submit]');
    if (stickyButton) {
      stickyButton.disabled = !available;
      stickyButton.textContent = available ? this.dataset.addLabel : this.dataset.soldoutLabel;
    }
    const stock = this.scope.querySelector('[data-bb-variant-stock]');
    const stockTemplate = [...this.querySelectorAll('[data-bb-stock-template]')]
      .find((node) => node.dataset.bbStockTemplate === input.value);
    if (stock && stockTemplate) stock.replaceChildren(stockTemplate.content.cloneNode(true));
    const status = this.querySelector('[data-bb-length-status]');
    if (status && updateUrl) {
      const title = input.closest('label').querySelector('.bb-length-picker__heading').textContent;
      status.textContent = `${title} — ${input.dataset.money}`;
    }
    // The existing form recalculates totals and submits the native variant normally.
    variantInput.dispatchEvent(new Event('input', { bubbles: true }));
    if (updateUrl && this.hasAttribute('data-update-url')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState(window.history.state, '', url);
    }
    this.dispatchEvent(new CustomEvent('blankabox:variant-change', {
      bubbles: true,
      detail: { variantId: input.value, userInitiated: updateUrl },
    }));
  }
}
if (!customElements.get('blankabox-variant-picker')) {
  customElements.define('blankabox-variant-picker', BlankaboxVariantPicker);
}
